import { Navigate, useLocation } from "react-router-dom";

/**
 * Maps legacy Django routes to their SPA equivalents.
 * Used for known path-to-path redirects after stripping language prefixes.
 */
const LEGACY_PATH_MAP: Record<string, string> = {
  "/dashboard": "/dashboard",
  "/dashboard/": "/dashboard",
  "/filters": "/advertisements",
  "/filters/": "/advertisements",
  "/account/edit": "/dashboard/profile",
  "/account/edit/": "/dashboard/profile",
  "/visit-request": "/request-service",
  "/visit-request/": "/request-service",
  "/application-requests": "/dashboard/requests",
  "/application-requests/": "/dashboard/requests",
  "/logs": "/dashboard",
  "/logs/": "/dashboard",
};

/**
 * Strips a language or API-version prefix and redirects to the SPA equivalent.
 * Handles: /ar/*, /en/*, /v4/*
 */
export function LegacyPrefixRedirect({ prefix }: { prefix: string }) {
  const { pathname, search } = useLocation();

  // Strip the prefix (e.g. "/ar/dashboard/" → "/dashboard/")
  let remaining = pathname.slice(prefix.length) || "/";
  if (!remaining.startsWith("/")) remaining = "/" + remaining;

  // Check for known legacy path mappings first
  const mapped = LEGACY_PATH_MAP[remaining];
  if (mapped) {
    return <Navigate to={mapped + search} replace />;
  }

  // /v4/listing-details/:id carried a numeric Django id that no current
  // listing has → the listings page.
  if (/^\/listing-details\/\d+/.test(remaining)) {
    return <Navigate to={`/advertisements${search}`} replace />;
  }

  // For /v4/properties/view-propertie-info/:id → /dashboard/properties/:id
  const propertyMatch = remaining.match(/^\/properties\/view-propertie-info\/(\d+)/);
  if (propertyMatch) {
    return <Navigate to={`/dashboard/properties/${propertyMatch[1]}${search}`} replace />;
  }

  // Default: redirect to home
  return <Navigate to={"/" + search} replace />;
}
